import { Container, Row } from 'react-bootstrap';
import { conditionAutocomplete } from '@medifind/interface';
import {
  useTrialConditionFilter,
  useTrialCriteriaFilter,
  useTrialInterventionTypeFilter,
  useTrialPhaseFilter,
  useTrialRadiusFilter,
  useTrialStatusFilter,
} from '@medifind/zustand';
import FilterChips from './FilterChips';
import LocationFilter from './LocationFilter';
import { RadiusFilter } from './RadiusFilter';
import StoreFilterAutocomplete from './StoreFilterAutocomplete';
import StoreFilterFieldMulti from './StoreFilterFieldMulti';
import styles from './ClinicalTrialResultFilterList.module.scss';

const ClinicalTrialResultFilterList = ({ criteriaKeywords, showTrialCondition }) => {
  const trialRadius = useTrialRadiusFilter();
  const trialCondition = useTrialConditionFilter();
  const trialPhase = useTrialPhaseFilter();
  const trialStatus = useTrialStatusFilter();
  const trialInterventionType = useTrialInterventionTypeFilter();
  const [criteriaValues, trialCriteria] = useTrialCriteriaFilter((state) => [state.selected, state]);
  const allSuggestions = criteriaKeywords ? criteriaKeywords.map((d) => ({ display: d, value: d })) : [];
  const criteriaAutocomplete = async (value) => {
    if (value.trim()) {
      return [
        { display: value, value: value.toLowerCase() },
        ...allSuggestions.filter((d) => d.value.toLowerCase().startsWith(value.toLowerCase())),
      ];
    } else {
      return allSuggestions;
    }
  };
  return (
    <Container className={styles['result-filter-list__container']}>
      {showTrialCondition && (
        <Row>
          <StoreFilterAutocomplete
            filter={trialCondition}
            label="Therapeutic Area"
            placeholder="Search for a therapeutic area..."
            autocompleteFunction={(input) =>
              conditionAutocomplete({ input, showAll: true })
                .then((res) =>
                  res.results.map((result) => ({
                    display: result.display,
                    value: result.projectId,
                    codingType: result.codingType,
                  })),
                )
                .catch(() => [])
            }
            prepopulateOnFocus
            fullWidth
            actLikeASelect
            showClearButton
            classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
          />
        </Row>
      )}
      <Row>
        <StoreFilterFieldMulti
          filter={trialPhase}
          label="Phase"
          placeholder="Any"
          classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
        />
      </Row>
      <Row>
        <StoreFilterFieldMulti
          filter={trialInterventionType}
          label="Intervention Type"
          placeholder="Any"
          classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
        />
      </Row>
      <Row>
        <StoreFilterFieldMulti
          filter={trialStatus}
          label="Status"
          placeholder="Any"
          classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
        />
      </Row>
      <Row>
        <LocationFilter label="Location:" />
      </Row>
      <Row>
        <RadiusFilter filter={trialRadius} label="Distance" />
      </Row>
      {/* <Row>
        <StoreFilterFieldInput
          filter={organizationName}
          label="Sponsor"
          placeholder="ex. Johns Hopkins"
          onInputChange={(...args) => updateOrganizationNameFilterOption(...args)}
          onValueClear={(...args) => clearOrganizationNameFilterOption(...args)}
          showClearButton
          classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
        />
      </Row>
      <Row>
        <StoreFilterFieldSingle
          filter={trialDateWithin}
          label="Date Within:"
          placeholder="Any"
          classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
        />
      </Row> */}
      <Row>
        <StoreFilterAutocomplete
          filter={trialCriteria}
          label={`Term Search`}
          placeholder="Ex. stem cell"
          autocompleteFunction={criteriaAutocomplete}
          prepopulateOnFocus
          fullWidth
          clearInputAfterSelect
          actLikeASelect
          showClearButton
          noResultsString="Press enter to add criteria"
          classes={{ label: styles['filter-label'], filter: styles['filter-container'] }}
        />
        <FilterChips
          values={criteriaValues}
          explanation={'You can select from the dropdown list OR enter your own terms to refine the search.'}
          onChipUpdate={(arr) => trialCriteria.setFilterValue(arr)}
        />
      </Row>
    </Container>
  );
};

export { ClinicalTrialResultFilterList as default, ClinicalTrialResultFilterList };
